<template>
	<div class="service_pack_detail">
		<div v-if="detail.pkgInfo" class="service_pack_detail_content" v-html="detail.pkgInfo"></div>
		<foot-button v-if="type != 'doctor'">
			<div class="service_pack_detail__action">
				<p
					><span>￥{{ amount }}</span></p
				>
				<!-- <p v-if="showMinToMax">
					<span>￥{{ min }}-{{max}}</span>
				</p>
				<p v-else>
					<span>￥{{ min }}</span>
				</p> -->
			</div>
			<van-button type="primary" block @click="goCreateOrder">立即购买</van-button>
		</foot-button>

		<!-- <selectGoods :show.sync="show" v-model="selectIds" /> -->
	</div>
</template>

<script>
// import selectGoods from './components/Dialog.vue'
export default {
    name: 'servicePackDetail',
    // components: { selectGoods },
    data () {
        return {
            // show: false,
        }
    },
    computed: {
        detailId () {
            return this.$route.params.id
        },
        detail () {
            return this.$store.getters['servicePack/getDetail']
        },
        type () {
            return this.$route.params.type || (this.orderSource == 2 ? 'serviceRecord' : '')
        },
        orderSource () {
            return this.$route.query.orderSource
        },
        patientId () {
            return this.$store.getters['account/getPatientId']
        },
        amount () {
            const { amount } = this.detail
            return amount
        }
        // min () {
        //     const { detailList } = this.detail || {}
        //     let arr = detailList ? detailList.filter(v => [2, 3].indexOf(v.optionType) > -1) : []
        //     return arr.length > 0 ? parseFloat(arr.map(v => v.sellingPrice).reduce((prev, curr) => {
        //         return prev + curr;
        //     })).toFixed(2) : 0
        // },
        // max () {
        //     const { detailList } = this.detail || {}
        //     return detailList.length > 0 ? parseFloat(detailList.map(v => v.sellingPrice).reduce((prev, curr) => {
        //         return prev + curr;
        //     })).toFixed(2) : 0
        // },
        // //是否展示价格区间
        // showMinToMax () {
        //     const { detailList } = this.detail || {}
        //     return detailList ? detailList.filter(v => v.optionType === 1).length > 0 : false
        // }
    },
    created () {
        this.init()
        // let _this = this
        // if(this.patientId){
        // 	this.$store.dispatch('account/actionSwitchPatient', {
        // 		params: this.patientId,
        // 			callback: () => {
        // 				_this.init()
        // 			},
        // 			dialog:false,
        // 	})
        // }else{
        // 	this.init()
        // }
    },
    methods: {

        init () {
            console.log(this.type)
            this.$store.dispatch('servicePack/apiGetServiceDetail', {
                params: {
                    id: this.detailId,
                    patientId: this.patientId,
                    type: this.type,
                },
                cb (data) {
                    document.title = data.title
                }
            })
        },
        async goCreateOrder () {
            // TODO:如果是服务包 先创建服务记录再去 订单确认，如果是服务记录 直接去
            let id = this.detailId
            console.log(this.orderSource)
            if (this.orderSource === '1') {
                const res = await this.$api.servicePack.patientCreateServiceRecord({
                    orderSource: 1,
                    patientId: this.patientId,
                    servicePackId: this.detail.id
                })
                if (!res.code) {
                    this.$store.commit('servicePack/SET_SERVICE_PACK_DETAIL', res.data)
                    id = res.data.id
                }
            }

            this.$router.push({
                path: `/order/confirm/${id}`
            })
        }
    }
};
</script>

<style scoped lang="less">
.service_pack_detail {
	padding-bottom: 28px;
	&__action {
		flex: 0 0 50%;
		p {
			font-family: PingFangSC-Regular;
			font-size: 32px;
			font-weight: normal;
			line-height: 38px;
			letter-spacing: 0.85px;
			color: @gray-9;
			> span {
				font-family: PingFangSC-Semibold;
				font-size: 44px;
				font-weight: 600;
				letter-spacing: 0.85px;
				color: #000;
			}
		}
	}
}
</style>

<style lang="less">
.service_pack_detail {
	&_content {
		word-break: break-all;

		img {
			width: 100%;
			max-width: 100%;
			object-fit: contain;
		}
	}
}
</style>
